import type { FaireProductEntity } from "../../entity_types/product";

export const p_sewnzfb6br: FaireProductEntity = {
  token: "p_sewnzfb6br",
  type: "product",
  name: "White Marble Rolling Pin and Wood Base",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/5352110778e912cd46eaa9198b54633e0392ce12846f0afdb587c030192b2c50.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/01c3fc874080acbff766f6aa382651411f30667aad607f9bf74ac5676d90b655.jpeg",
    "https://cdn.faire.com/fastly/9dcf0f5b62ae90c5f950e5db208df2110653dfcb513be5adddb5e07a079be815.jpeg",
    "https://cdn.faire.com/fastly/5258916bdddf4dabefe694ff62d521bcbd15878628b8346758dc5c28d7ead637.jpeg",
    "https://cdn.faire.com/fastly/00857d2eabe17c4996f62b6bfc1b7cdc10e39190de711d3ecadf4abf18bd8a71.jpeg",
    "https://cdn.faire.com/fastly/6cd531ce4c11b35dc9733fc09b8661ec2bfc476c700142edb78b0eaec6fb3d75.jpeg",
  ],
  priceDollars: 15,
  description:
    "Elevate your kitchen aesthetics and baking skills with our White Marble Rolling Pin from Agra, India. Perfect for home bakers and pastry chefs alike, this rolling pin is made of stunning white marble with subtle gray veining, adding a touch of sophistication to any kitchen. Marble is naturally cool, helping to prevent dough from sticking. The balanced weight makes it easy to control and apply consistent pressure and uniform thickness.\n\nOur collection of white marble kitchen tools is sourced from Agra, India; the city renowned for the iconic Taj Mahal. \n\nHand Washing: Always wash your white marble kitchen tools by hand using warm, soapy water. Avoid using harsh or abrasive detergents, as they can damage the marble's surface.\n\nOil Application: Occasionally, apply a food-safe mineral oil to the surface of your marble tools to help maintain their luster. This also helps prevent them from absorbing food stains.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:26.514Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
